<!-- Cadre de détail de la prestation -->
<ng-container *ngIf="isOuvert">
    <ng-container *ngFor="let nature of dossier.listeNaturesDTO; let isFirst = first;">
            <nature-item [nature]="nature" [dossier]="dossier" [canGoToSbt]="canGoToSbt(isFirst)" (goToSbt)="goToSBT(dossier.idDossier)"></nature-item>
    </ng-container>
</ng-container>
